import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class LpClassic extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
        dispatch(Action.do('createGroupsOfTeamStacks', preparedPlayers.groupedBy.property('team')));
    }

    limitPositions({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersGroupedByAllowedPositions = preparedPlayers.groupedBy.allowedPositions();
        const teams = groupObjectsByProp(playersGroupedByAllowedPositions, 'team');

        let maxSingleTeamPlayers = sportConfig.getConfigProp('maxSingleTeamPlayers'),
            result = '';

        if (maxSingleTeamPlayers) {
            Object.keys(teams).map((teamName) => {
                let str = '',
                    addedPlayers = [];

                teams[teamName].map((player) => {
                    if (inArray(player.uniqueId, addedPlayers)) {
                        return;
                    }

                    str += '+' + getSimplexUnitName(player.uniqueId);
                    addedPlayers.push(player.uniqueId);
                });

                if (str) {
                    result += str + '<=' + maxSingleTeamPlayers + '\n';
                }
            });
        }

        return result;
    }

    prepareSectionByPosition({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const positions = sportConfig.getConfigProp('positions');
        const playersGroupedByAllowedPositions = preparedPlayers.groupedBy.allowedPositions();

        let result = '';

        Object.keys(positions).map(function (pos) {
            let playersOnPos = {},
                addedPlayers = [],
                posObj = positions[pos];

            playersGroupedByAllowedPositions.map((player) => {
                if (player.position != pos || inArray(player.uniqueId, addedPlayers)) {
                    return;
                }

                if (!playersOnPos.hasOwnProperty(player.team)) {
                    playersOnPos[player.team] = '';
                }

                playersOnPos[player.team] += '+' + getSimplexUnitName(player.uniqueId);

                addedPlayers.push(player.uniqueId);
            });

            if (isEmpty(playersOnPos)) {
                return;
            }

            let str = '';

            Object.keys(playersOnPos).map((teamName) => {
                if (posObj.maxFromOneTeam) {
                    result += playersOnPos[teamName] + '<=' + posObj.maxFromOneTeam + '\n';
                } else {
                    str += playersOnPos[teamName];
                }
            });

            if (str) {
                let maxPlayers = posObj.maxPlayers;
                let minPlayers = posObj.minPlayers;

                if (maxPlayers == minPlayers) {
                    result += str + '=' + maxPlayers + '\n';
                } else {
                    if (false !== Boolean(minPlayers)) {
                        result += str + '=>' + minPlayers + '\n';
                    }
                    if (false !== Boolean(maxPlayers)) {
                        result += str + '<=' + maxPlayers + '\n';
                    }
                }
            }
        });

        return result;
    }

    playerPositionStacking() {
        const {
            playerPositionStacking: stacking,
        } = Action.getState();

        return this.exec('keyPlayerStacking', {
            isOverlapPrimaryAndSecondaryStacksAllowed: stacking.isOverlapPrimaryAndSecondaryStacksAllowed(),
        });
    }

    subjectToPermanent() {
        const constraints = {
            // DO NOT use prepareSectionByPosition and prepareSectionByPositionWithFlexMaxExposure together
            // position: this.exec('prepareSectionByPosition', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {}, ''),
            // teams: this.exec('prepareSectionByTeam', {}, ''),
            teams: this.exec('team', {}, ''),
            limitPositions: this.exec('limitPositions', {}, ''),
            minTeams: this.exec('minTeams', {}, ''),
            games: this.exec('prepareSectionByGame', {}, ''),
            teamNameStacking: this.exec('teamNameStacking', {}, ''),
            keyPlayerStacking: this.exec('playerPositionStacking', {}, ''),
            passReceiver: this.exec('prepareSectionByPassReceiver', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            flexExposureMax: this.exec('flexMaxExposure', {}, ''),
            correlationStackingPrimaryRule: this.exec('correlationStackingPrimaryRule', {}, ''),
            correlationStackingSecondaryRule: this.exec('correlationStackingSecondaryRule', {}, ''),
            correlationStackingUniversalRule: this.exec('correlationStackingUniversalRule', {}, ''),
            correlationStackingRestrictedPlayers: this.exec('correlationStackingRestrictedPlayers', {}, ''),
            keyPlayerStackingComboExpMax: this.exec('keyPlayerStackingComboExpMax', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
